import { Component, OnDestroy, OnInit } from '@angular/core';
import { ModalController, NavController, Platform } from '@ionic/angular';
import { DeviceService } from '../../../providers/device-service/device-service';
import { DeviceInfo } from '../../../data/device-info';
import { AppInfo } from '../../../data/app-info';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
/**
 * Created by Ashok on 29-03-2016.
 */
@Component({
  templateUrl: "about.page.html",
  selector: "about-page",
  styleUrls: ['about.page.scss'],
})
export class AboutPage implements OnInit, OnDestroy {

  deviceInfo: DeviceInfo = {
    deviceId: 'unknown', virtual: true
  };
  appInfo: AppInfo = {};

  constructor(private nav: NavController,
    private Location: Location,
    private router: Router,
    private deviceService: DeviceService,
    private modalCtrl:ModalController,
    private platform: Platform) {
    this.platform = platform;
    
      this.modalCtrl.dismiss();
  }

  ngOnInit() {
    this.deviceService.getDeviceInfo()
      .then((deviceInfo: DeviceInfo) => {
        this.deviceInfo = deviceInfo;
      });
    this.deviceService.getAppInfo().then((appInfo: AppInfo) => {
      this.appInfo = appInfo;
    })

  }
  ngOnDestroy() {

  }
  versionCode() {
    // return this.platform.versions()
  }

  gotopage() {
    this.Location.back()
  }

  isCordova() {
    return this.platform.is('capacitor');
  }
  // async sendMessage() {
  //     let deviceInfo: DeviceInfo = await this.deviceService.getDeviceInfo();
  //
  //     this.stompService.sendMessage(deviceInfo,
  //         '/app//mygolf2u-ws/device/register');
  // }
}
